import { SubscriptionData } from '@/app/subscription-ui/entities/subscription-data.interface';
import { ConfigurationAbstract } from '@/common/configuration.abstract';
import { DOMUtil, SubscriptionConfiguration, TranslationServiceConfiguration } from 'webshop-modules';

export class ConfigurationFactory extends ConfigurationAbstract {

    private readonly applicationData: SubscriptionData;
    private readonly endpoint: string;
    private readonly poolId: number;
    private readonly staticUrl: string;
    private readonly scriptName = 'subscription-ui.js';

    public constructor() {
        super();
        const scriptElement = DOMUtil.getInjectedConfigurationScript(document, this.scriptName) as HTMLScriptElement;

        this.applicationData = JSON.parse(this.getDataAttributeFor('data-application', scriptElement));
        this.endpoint = this.getDataAttributeFor('data-endpoint', scriptElement);
        this.poolId = Number.parseInt(this.getDataAttributeFor('data-pool-id', scriptElement), 10);
        this.staticUrl = this.getDataAttributeFor('data-static', scriptElement);
    }

    public getApplicationData(): SubscriptionData {
        return this.applicationData;
    }

    public getSubscriptionConfiguration(): SubscriptionConfiguration {
        return {
            clientId: this.poolId,
            endpoint: this.endpoint,
        };
    }

    public getTranslationConfiguration(): TranslationServiceConfiguration {
        return {
            clientId: this.poolId,
            staticUrl: this.staticUrl,
        };
    }

}
